import { Outlet } from "react-router-dom";

export default function NotFound() {
  const url = window.location.pathname;
    return (
      <div>  
        <main style={{ padding:"6rem 0", textAlign:"center", backgroundColor:"#f1fcff" }}>
          <h2 style={{fontSize:"4em", margin:"1em auto 10px", fontWeight:"500",color:"#333333"}}>404 Not Found</h2>
          <p style={{fontSize:"1.3em", color:"#0081cb", margin:"5px"}} key={url}>{url}</p>
          <p style={{fontSize:"1.3em", color:"#696969"}} key={url}>This page doesn't exist</p>
          
        </main>
        <Outlet />
      </div>
    );
  }